import { useMemo } from 'react'

import { CLOSE_SESSION_TYPES } from '@lyrahealth-inc/shared-app-logic/src/features/calendar/provider/types'
import { getCloseSessionType } from '@lyrahealth-inc/shared-app-logic/src/features/calendar/provider/utils'

/**
 * Get the close session type for a given appointment
 */
export const useGetCloseSessionType = ({
  appointmentStatus,
  engageDAProvider,
  isInPast,
  lyraEventType,
  onCloseSession,
  onCompleteNote,
  onViewCompletedNote,
  sessionNeedsNote,
  isLegacyDAAppointment,
  isChargeReversed,
  isCoveredLateCancel,
  isClientOwedLateCancel,
  showLateCancellations,
}: UseGetCloseSessionTypeParams): CLOSE_SESSION_TYPES => {
  return useMemo(() => {
    if (lyraEventType !== 'session' || !onCloseSession || !onCompleteNote || !onViewCompletedNote) {
      return CLOSE_SESSION_TYPES.NONE
    }

    return getCloseSessionType({
      appointmentStatus,
      isDAEngageProvider: engageDAProvider,
      isInPast,
      sessionNeedsNote,
      isLegacyDAAppointment,
      isChargeReversed,
      isCoveredLateCancel,
      isClientOwedLateCancel,
      showLateCancellations,
    })
  }, [
    isInPast,
    lyraEventType,
    onCloseSession,
    onCompleteNote,
    onViewCompletedNote,
    appointmentStatus,
    isChargeReversed,
    engageDAProvider,
    isLegacyDAAppointment,
    sessionNeedsNote,
    isCoveredLateCancel,
    isClientOwedLateCancel,
    showLateCancellations,
  ])
}

type UseGetCloseSessionTypeParams = {
  appointmentStatus?: string
  engageDAProvider: boolean
  isInPast: boolean
  lyraEventType: string
  onCloseSession?: (appointmentId: number, clientId: string | null) => void
  onCompleteNote?: (appointmentId: number, clientId: string) => void
  onViewCompletedNote?: (appointmentId: number) => void
  sessionNeedsNote: boolean
  isLegacyDAAppointment: boolean
  isChargeReversed: boolean
  isCoveredLateCancel?: boolean
  isClientOwedLateCancel?: boolean
  showLateCancellations?: boolean
}
